import { render, staticRenderFns } from "./ShortLinkWhats.vue?vue&type=template&id=0882d53c&scoped=true&"
import script from "./ShortLinkWhats.vue?vue&type=script&lang=js&"
export * from "./ShortLinkWhats.vue?vue&type=script&lang=js&"
import style0 from "./ShortLinkWhats.vue?vue&type=style&index=0&id=0882d53c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0882d53c",
  null
  
)

export default component.exports